// @ts-ignore
import { Backbone } from '../../../vendor';

export const ApiRequester: (path:any, payload?:any, method?: string) => () => Promise<unknown> = (path:any, payload?:any, method:string = "GET"):() => Promise<unknown> => () => {
  const AuthorizationRequest = Backbone.Model.extend({
      urlRoot: "" + path,
  });
  return new Promise((resolve: (value: (PromiseLike<unknown> | unknown)) => void, reject: (reason?: any) => void):void => {
    const authorizationRequest = new AuthorizationRequest();
    authorizationRequest.fetch({
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload),
              success: (model:any, response:any):void => {
                  resolve(response);
              },
              error: (model:any, response:any):void => {
                  reject(response);
              }
  })
   
  });
};